









































































































































































import CampoDeCnpjOuCpf from "@/components/ui/CampoDeCnpjOuCpf.vue"
import DataTableDeCrud from "@/components/ui/DataTableDeCrud.vue"
import DatePicker from "@/components/ui/DatePicker.vue"
import { Voucher } from "@/models"
import { Inject } from 'inversify-props'
import { dateTimeToPtBrFormat } from "@/shareds/date/date-utils"
import { aplicarMascaraParaCpfOculto, formatarCnpjOuCpf } from "@/shareds/formatadores"
import { maiorOuIgualAZero, obrigatorio } from "@/shareds/regras-de-form"
import AlertModule from "@/store/vuex/aplicacao/AlertModule"
import type { VoucherServiceAdapter } from "@/usecases"
import axios, { CancelTokenSource } from "axios"
import { Component, Ref, Vue, Watch } from "vue-property-decorator"
import { DataOptions } from "vuetify"
import moment from "moment"
import SeletorDeLojasDoUsuario from "@/components/loja/SeletorDeLojasDoUsuario.vue"
import { Loja } from "@/models"
import { GrupoEconomico } from "@/models/GrupoEconomico"
import SeletorDeGruposEconomicos from "@/components/loja/SeletorDeGruposEconomicos.vue"
import DialogoDePendentesDeDisparo from "./DialogoDePendentesDeDisparo.vue"
import { AcaoDeCashback } from "@/models/AcaoDeCashback"
import { FindCashbackUseCase, FindImportacaoUseCase } from "@/usecases"
import UserLoginStore from "@/store/vuex/authentication/UserLoginStore"


@Component({
	components: {
		DatePicker,
		DataTableDeCrud,
		CampoDeCnpjOuCpf,
		SeletorDeLojasDoUsuario,		
		SeletorDeGruposEconomicos,
		DialogoDePendentesDeDisparo,
	},
})
export default class TelaDeManutencaoCashback extends Vue {
	@Ref() formDePeriodo!: HTMLFormElement
	@Ref() dialogoDePendentesDeDisparo!: DialogoDePendentesDeDisparo

	dataFinal: string | null = null
	dataInicio: string | null = null
	diasParaAlteracao = 0
	dataParaAlteracao: string | null = null
	cnpjCpfDoCliente = ''

	carregando = false
	atualizandoCashback = false
	totalRegistros = -1

	listaDeCashback: Voucher[] = []
	lojas: Loja[] = []
	cashback: Voucher | null = null

	@Inject('VoucherServiceAdapter')
	private voucherService!: VoucherServiceAdapter

	cancelToken: CancelTokenSource | null = null
	lojaId: string | null = null
	
	grupoEconomico: GrupoEconomico | null = null
	dataLimiteCashbackEmDobro: string | null = null
	acoesDeCashback: AcaoDeCashback [] = []
	acaoDeCashbackId: string | null = null
	findCashbackUseCase = new FindCashbackUseCase()
	acaoDeCashbackAlteracaoDeDataId: string | null = null
	acoesDeCashbackDobro: AcaoDeCashback [] = []
	acoesDeCashbackAlteracaoData: AcaoDeCashback [] = []
	findImportacaoUseCase = new FindImportacaoUseCase

	paginacao: DataOptions = {
		page: 0,
		itemsPerPage: 10,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: false,
		mustSort: false,
	}

	obrigatorio = obrigatorio
	maiorOuIgualAZero = maiorOuIgualAZero

	headers = [
		{ text: 'Cliente', value: 'razaoSocialOuNome' },
		{ text: 'CPF/CNPJ', value: 'cnpjOuCpfFormatado' },
		{ text: 'Gerado', value: 'dataHoraGeracao' },
		{ text: 'Vencimento', value: 'Vencimento' },
		{ text: 'Valor R$', value: 'valorCashback' },
	]

	gerarDataHora(data?: string | null, hora?: string | null): string | undefined {
		return moment(`${data} ${hora}`, 'YYYY-MM-DD HH:mm').toISOString(true)
	}	

	get disableSeletorDeLojas() {
		return !!this.grupoEconomico;
	}

	get disableSeletorDeGrupos() {
		return !!this.lojaId;
	}
	
	@Watch('lojaId')
	onLojaChange(newVal) {
		if (newVal) {
			this.grupoEconomico = null
		}
	}

	@Watch('grupoEconomico')
	onGrupoEconomicoChange(newVal) {
		if (newVal) {
			this.lojaId = null
		}
	}

	async buscar() {
		if (this.cancelToken) this.cancelToken.cancel()
		if (!this.dataInicio || !this.dataFinal ||
			(this.dataInicio && this.dataInicio.length === 0) ||
			(this.dataFinal && this.dataFinal.length === 0))
			return		

		try {
			this.carregando = true
			this.cancelToken = axios.CancelToken.source()
			const params = {
				page: this.paginacao.page - 1,
				cpfOuCnpj: this.cnpjCpfDoCliente || null,
				dataInicio: this.gerarDataHora(this.dataInicio, '00:00'),
				dataFinal: this.gerarDataHora(this.dataFinal, '23:59'),
				lojaId: this.lojaId,
				tipos: ['Cashback'],
				size: this.paginacao.itemsPerPage,
				grupoEconomicoId: this.grupoEconomico?.id,
				sort: 'expiracao,asc',
			}
			
			const axiosConfig = {
				cancelToken: this.cancelToken.token,
			}
			
			const page = await this.voucherService.findVouchers(params, axiosConfig)
			this.totalRegistros = page.totalElements
			this.listaDeCashback = page.content
			this.carregando = false
		} catch (error: any) {
			if (axios.isCancel(error)) return
			AlertModule.setError(error)
			this.carregando = false
		}
	}

	get usuario() {
		return UserLoginStore.usuario?.id
	}

	get permiteAbrirDiversosProcessosDeImportacao(){
		if(!UserLoginStore.perfil) return false
		return UserLoginStore.perfil.permissoes.includes('permite-abrir-diversos-processos')
	}

	async alterarCashbackEmMassa() {
		this.atualizandoCashback = true
		if(!this.usuario) return

		if(!this.permiteAbrirDiversosProcessosDeImportacao){
			const possuiProcessoEmAberto = await this.findImportacaoUseCase.possuiImportacoesEmAbertoNoUsuarioLogado(this.usuario);

			if(!possuiProcessoEmAberto){
				AlertModule.setError('Já existe um processo em aberto para o usuario, aguarde finalizar para prosseguir!');
				this.atualizandoCashback = false;
				return
			}
		}

		try {
			const command = {
				cpfOuCnpj: this.cnpjCpfDoCliente || null,
				dataInicio: this.gerarDataHora(this.dataInicio, '00:00'),
				dataFinal: this.gerarDataHora(this.dataFinal, '23:59'),
				acaoDeCashbackId: this.acaoDeCashbackAlteracaoDeDataId || null,
				tipos: ['Cashback'],
				lojaId: this.lojaId,
				grupoEconomicoId: this.grupoEconomico?.id,
			}

			this.voucherService.updateVoucherEmMassa(command)
			AlertModule.setInfo("Atualização em andamento. Você receberá uma notificação assim que a atualização for concluída")
			this.atualizandoCashback = false
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	async dobrarCashbackEmMassa() {
		this.atualizandoCashback = true
		try {
			const command = {
				cpfOuCnpj: this.cnpjCpfDoCliente || null,
				dataInicio: this.gerarDataHora(this.dataInicio, '00:00'),
				dataFinal: this.gerarDataHora(this.dataFinal, '23:59'),
				acaoDeCashbackId: this.acaoDeCashbackId || null,
				tipos: ['Cashback'],
				lojaId: this.lojaId,
				grupoEconomicoId: this.grupoEconomico?.id,
			}
			
			this.voucherService.dobraVoucherEmMassa(command)
			AlertModule.setInfo("Atualização em andamento. Você receberá uma notificação assim que a atualização for concluída")
			this.atualizandoCashback = false
		} catch (e) {
			AlertModule.setError(e)
		}
	}

	get itensFormatados() {
		return this.listaDeCashback.map(cashback => ({
			...cashback,
			cnpjOuCpfFormatado: cashback.cliente.cnpjOuCpf.length <= 11
				? aplicarMascaraParaCpfOculto(cashback.cliente.cnpjOuCpf)
				: formatarCnpjOuCpf(cashback.cliente.cnpjOuCpf),
			dataHoraGeracao: cashback.dataHoraGeracao != null ? dateTimeToPtBrFormat(cashback.dataHoraGeracao) : '- -',
			Vencimento: cashback.expiracao != null ? dateTimeToPtBrFormat(cashback.expiracao) : '- -',
			razaoSocialOuNome: cashback.cliente.razaoSocialOuNome,
			valorCashback: cashback.valor.toLocaleString('pt-BR', {
				style: 'currency',
				currency: 'BRL',
			}),

		}))
	}

	@Watch('paginacao', { deep: true })
	onChangePaginacao = this.buscar

	abrirDialogoDePendentesDeDisparo(){
		if (this.cancelToken) this.cancelToken.cancel()
			
		const params = {
			cpfOuCnpj: this.cnpjCpfDoCliente || null,
			lojaId: this.lojaId,
			tipos: ['Cashback'],
			grupoEconomicoId: this.grupoEconomico?.id || null,
		}
		this.dialogoDePendentesDeDisparo.mostrar(params);
	}

	@Watch('lojaId', { immediate: true, deep: true })
	async onChangeLojaId(){
		this.acaoDeCashbackId = null
		this.acoesDeCashback = await(this.findCashbackUseCase.findListaAcoesDeCashback({lojaId: this.lojaId}));
		this.acoesDeCashbackDobro = this.acoesDeCashback.filter(acao => acao.acaoManutencaoDeCashback != null && acao.acaoManutencaoDeCashback === 'Dobro de Cashback')
		this.acoesDeCashbackAlteracaoData = this.acoesDeCashback.filter(acao => acao.acaoManutencaoDeCashback != null && acao.acaoManutencaoDeCashback === 'Alteração de data')
	}

	@Watch('grupoEconomico', { immediate: true, deep: true })
	async onChangeGrupoEconomico(){
		if (this.grupoEconomico === null) return

		this.acaoDeCashbackId = null
		this.acoesDeCashback = await(this.findCashbackUseCase.findListaAcoesDeCashback({grupoEconomicoId: this.grupoEconomico.id}));
		this.acoesDeCashbackDobro = this.acoesDeCashback.filter(acao => acao.acaoManutencaoDeCashback != null && acao.acaoManutencaoDeCashback === 'Dobro de Cashback')
		this.acoesDeCashbackAlteracaoData = this.acoesDeCashback.filter(acao => acao.acaoManutencaoDeCashback != null && acao.acaoManutencaoDeCashback === 'Alteração de data')
	}

	@Watch('acoesDeCashback', { immediate: true, deep: true })
	onAcoesDeCashbackChange(newVal: AcaoDeCashback[]) {
		if (!newVal.length || !newVal.some(acao => acao.id === this.acaoDeCashbackId)) {
			this.acaoDeCashbackId = null; 
		}
	}
}
